import {
  ENVIRONMENT_INTEGRATIONS,
  ENVIRONMENTS_INTEGRATIONS,
} from '@elementary/common-ui/constants/queryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from '../../services/settingsApi';
import useSnackbar from '../useSnackbar';

type Props = {
  envId?: string;
};

const useFivetranIntegration = ({ envId }: Props) => {
  const queryClient = useQueryClient();
  const { openSnackbar } = useSnackbar();

  const createMutation = useMutation(
    () => api.createFivetranIntegration(envId!),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENVIRONMENT_INTEGRATIONS, envId]);
        queryClient.invalidateQueries([ENVIRONMENTS_INTEGRATIONS]);
        openSnackbar({
          message: 'Fivetran integration created successfully',
          variant: 'success',
        });
      },
    },
  );

  const revealMutation = useMutation((integrationId: string) =>
    api.fetchFivetranIntegration(envId!, integrationId),
  );

  return {
    createMutation,
    revealMutation,
  };
};

export default useFivetranIntegration;
